import { Popover2, Popover2Props } from "@blueprintjs/popover2"
import React from "react"
import "./popover.scss"
export type CustomPopoverProps = Popover2Props & {
  children?: React.ReactNode
  /**
   * @deprecated pass node as children instead
   */
  target?: React.ReactNode
}
const CustomPopover = ({ children, target, ...props }: CustomPopoverProps) => {
  return <Popover2 {...props}>{children || target}</Popover2>
}

export default CustomPopover
